import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
    useFetch,
    useForm,
    useGrid,
    useModal,
    useResource,
    useStore,
    useTab,
    useToast,
    usePage,
    useAuth,
} from "@/comn/hooks";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Page, Group, Layout, Tab, Button, FormControl } from "@/comn/components";
import {
    APIS,
    URLS,
    SF_USR_FRGNR_VHCL_FORM,
    SG_VHCL_INFO_LIST,
    SF_FEE_TAB_FROM,
} from "@/tra/tancis/ptli/usr/frgnr/services/PtliUsrFrgnrService";

import { PTLI0919005S } from "@/tra/tancis/ptli/usr/frgnr/PTLI0919005S";

/*
 * Vehicle Information Registration
 * !== 외국인 차량 등록 ==!
 */
export const PTLI0919004S = (props: any) => {
    const { data, handleSave } = props;
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_cgmi0067", "auth_ptli0042", "auth_ptlianyADM"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const [saveStat, setSaveStat] = useState("");

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "LCM0001" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Vehicle Information Registration !== 외국인 차량 등록 Form ==!
        usrFrgnrVhclForm: useForm({
            defaultSchema: SF_USR_FRGNR_VHCL_FORM,
            defaultValues: {
                ...data,
                trptAppNo: data.appNo,
                trptLcneNo: data.cstmLcneNo,
                trptIssDtm: data.trptIssDtm,
                owrNm: data.rgsrTrdrNm,
            },
        }),

        // Fee Tab Form !== 수수료 정보 Form ==!
        feeTabForm: useForm({
            defaultSchema: SF_FEE_TAB_FROM,
            defaultValues: {
                ...(pgeStore?.form || {}),
                frgnVhclRgsrFeeVal: 300,
            },
        }),
    };

    const tab = useTab({
        defaultSchema: {
            id: "tab_fee",
            schema: [{ label: t("T_FEE_DTL") }],
        },
    });

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {};

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        saveFrgnrVhcl: useFetch({
            api: (data) => {
                return APIS.saveFrgnrVhcl(data);
            },
            onSuccess: (data) => {
                setSaveStat("save"); // Fee Information Tab - 수수료 탭 활성화
                handleSave("save"); // Data sent to the parent pane - 부모창으로 보내는 데이터
                form.usrFrgnrVhclForm.setEditable(false);

                modal.openModal({
                    content: "msg.00003",
                    onConfirm: () => {},
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: error.response.data.errorMessage,
                });
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        saveFrgnrVhcl: form.usrFrgnrVhclForm.handleSubmit(
            (data) => {
                // 저장 시 checkbox [] -> String으로 변경하여 저장
                let reqData = { ...data };

                if (data.tankrYn != null) {
                    reqData = {
                        ...reqData,
                        tankrYn: data.tankrYn.toString(),
                    };
                }

                if (data.trnsGodsIdtnYn != null) {
                    reqData = {
                        ...reqData,
                        trnsGodsIdtnYn: data.trnsGodsIdtnYn.toString(),
                    };
                }

                reqData = {
                    ...reqData,
                    trprOwrsTrckNo: data.trprOwrsTrckNo + 1,
                    rmrk: "I",
                };

                modal.openModal({
                    content: "msg.00101",
                    onConfirm: () => {
                        fetch.saveFrgnrVhcl.fetch(reqData);
                    },
                });
            },
            () => {
                toast.showToast({ type: "warning", content: "msg.00002" });
            },
        ),
    };

    const render = {};

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {}, []);

    return (
        <Page info={true}>
            <Group>
                <Group.Body>
                    <Layout direction="col" gap={4}>
                        <Group.Section>
                            <Layout direction="col" gap={4}>
                                <Layout direction="col">
                                    <Layout>
                                        <Layout.Left>
                                            <Group.Title title={t("T_VHCL_INFO")} titleSize={2}></Group.Title>
                                        </Layout.Left>
                                    </Layout>

                                    <Group.Section>
                                        <Group.Row>
                                            <Group.Control
                                                letterCase="upper"
                                                {...form.usrFrgnrVhclForm.schema.vhclRgsrNo}
                                                controlSize={10}
                                            ></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.owrNm}></Group.Control>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.issRegnNm}></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.appNo}></Group.Control>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.cardRgsrNo}></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.trptAppNo}></Group.Control>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.trptLcneNo}></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.trptIssDtm}></Group.Control>
                                            <Group.Control
                                                {...form.usrFrgnrVhclForm.schema.insrCvrPtclCn}
                                            ></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                        <Group.Control
                                            {...form.usrFrgnrVhclForm.schema.latraCrteNo}
                                        ></Group.Control>
                                        <Group.Control
                                            {...form.usrFrgnrVhclForm.schema.atcdFileDto}
                                        ></Group.Control>
                                        </Group.Row>

                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.vhclMkerNm}></Group.Control>
                                            <Group.Control
                                                {...form.usrFrgnrVhclForm.schema.vhclBodyTpNm}
                                            ></Group.Control>
                                        </Group.Row>

                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.mnfcYy}></Group.Control>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.vhclClrNm}></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.engnNo}></Group.Control>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.chssNo}></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control
                                                {...form.usrFrgnrVhclForm.schema.vhclDpacInfoCn}
                                            ></Group.Control>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.vhclAxleNo}></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.carygCapc}></Group.Control>
                                            <Group.Control
                                                {...form.usrFrgnrVhclForm.schema.trptVhclMlg}
                                            ></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.emptWght}></Group.Control>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.tankrYn}></Group.Control>
                                        </Group.Row>

                                        <Group.Row>
                                            <Group.Label
                                                label={t("L_TRANS_GODS_YN")}
                                                labelSize={12}
                                                required
                                            ></Group.Label>
                                        </Group.Row>

                                        <Group.Row>
                                            <Group.Col>
                                                <FormControl {...form.usrFrgnrVhclForm.schema.trnsGodsIdtnYn} />
                                            </Group.Col>
                                        </Group.Row>
                                    </Group.Section>
                                </Layout>
                            </Layout>
                        </Group.Section>
                    </Layout>

                    <Layout direction="col" gap={4}>
                        <Group.Section>
                            <Layout direction="col" gap={4}>
                                <Layout direction="col">
                                    <Layout>
                                        <Layout.Left>
                                            <Group.Title title={t("T_LCNE")} titleSize={2}></Group.Title>
                                        </Layout.Left>
                                    </Layout>

                                    <Group.Section>
                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.trptLcneNo}></Group.Control>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.lcneIssDtm}></Group.Control>
                                        </Group.Row>

                                        <Group.Row>
                                            <Group.Control
                                                {...form.usrFrgnrVhclForm.schema.lcneVldtyDays}
                                                controlSize={10}
                                            ></Group.Control>
                                        </Group.Row>
                                    </Group.Section>
                                </Layout>
                            </Layout>
                        </Group.Section>
                    </Layout>

                    <Layout direction="row">
                        <Layout.Right>
                            {saveStat != "save" && (
                                <Button
                                    role="save"
                                    onClick={() => {
                                        handler.saveFrgnrVhcl();
                                    }}
                                />
                            )}
                            <Button
                                role="close"
                                onClick={() => {
                                    if (data.trprOwrsTrckNo == 0) {
                                        modal.openModal({
                                            content: "msg.esw.00111",
                                        });
                                    } else {
                                        modal.closeModal();
                                    }
                                }}
                            ></Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
        </Page>
    );
};
